import { Button } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledTwoFactorForm = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 2.8rem;
`;

export const StyledFullWidthButton = styled(Button)`
  width: 100%;
`;

export const StyledControllerWrapper = styled.div``;
